import { Validators } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-feedback-dialog",
  templateUrl: "./feedback-dialog.component.html",
  styleUrls: ["./feedback-dialog.component.scss"],
})
export class FeedbackDialogComponent implements OnInit,OnDestroy{
  actions: any[];
  feedbackForm: FormControl = new FormControl("", Validators.required);
  private destroy$ = new Subject<void>();
  constructor(private dialogRef: MatDialogRef<FeedbackDialogComponent>) {}

  ngOnInit(): void {}

  close(e?) {
    if (e === "Submit") {
      this.dialogRef.close(this.feedbackForm.value);
    } else {
      this.dialogRef.close(e);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
}
